import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import OgMetaInfo from '../OgMetaInfo.json';

const BASE_URL = "https://www.binaryrepublik.com";

const useMetaTags = (title: string, description: string, keywords: string) => {
  const location = useLocation();

  useEffect(() => {
    document.title = title;

    const updateMetaTag = (selector: string, attr: string, value: string) => {
      let metaTag = document.querySelector(selector);

      if (!metaTag) {
        metaTag = document.createElement("meta");
        if (selector.includes("property")) {
          metaTag.setAttribute("property", attr);
        } else {
          metaTag.setAttribute("name", attr);
        }
        document.head.appendChild(metaTag);
      }

      metaTag.setAttribute("content", value);
    };

    updateMetaTag('meta[name="description"]', "description", description);
    updateMetaTag('meta[name="keywords"]', "keywords", keywords);

    const path = location.pathname.replace(/\/$/, '');

    let image =
      path === "/contact"
        ? "/assets/Images/common/contact.webp"
        : [
          "/azure-aws-cloud",
          "/uiux-design",
          "/microsoft-power-platform",
          "/mobile-solutions",
          "/case-study/ai-knowledge-casting-platform-us-csod-5"
        ].includes(path)
          ? "/assets/Images/common/career.webp"
          : "";
    if (image) {
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = image;
      document.head.appendChild(link);
    }
    const updateCanonicalLink = (url: string) => {
      let linkTag = document.querySelector('link[rel="canonical"]');

      if (!linkTag) {
        linkTag = document.createElement("link");
        linkTag.setAttribute("rel", "canonical");
        document.head.appendChild(linkTag);
      }

      linkTag.setAttribute("href", url);
    };

    const cleanPath = location.pathname.replace(/\/$/, '');
    const canonicalUrl = `${BASE_URL}${cleanPath}`;
    updateCanonicalLink(canonicalUrl);

    // OG & Twitter
    const matchedMeta = OgMetaInfo.find(route => location.pathname === route.path);

    if (matchedMeta) {
      updateMetaTag('meta[property="og:title"]', "og:title", matchedMeta.ogTitle);
      updateMetaTag('meta[property="og:description"]', "og:description", matchedMeta.ogDescription);
      updateMetaTag('meta[name="twitter:title"]', "twitter:title", matchedMeta.twitterTitle);
      updateMetaTag('meta[name="twitter:description"]', "twitter:description", matchedMeta.twitterDescription);
    }

  }, [title, description, keywords, location.pathname]);
};

export default useMetaTags;
